import { render, staticRenderFns } from "./RatesCrossDock.vue?vue&type=template&id=1196cd02&scoped=true&"
import script from "./RatesCrossDock.vue?vue&type=script&lang=js&"
export * from "./RatesCrossDock.vue?vue&type=script&lang=js&"
import style0 from "./RatesCrossDock.vue?vue&type=style&index=0&id=1196cd02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1196cd02",
  null
  
)

export default component.exports